module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/233-transnistria-be0da094842a6ae36183b140ae65dea5.svg";